/* tslint:disable */
/* eslint-disable */
/**
 * Yaway Workshop API
 * Yaway Workshop API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiWorkshop,
    ApiWorkshopFromJSON,
    ApiWorkshopFromJSONTyped,
    ApiWorkshopToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApiWorkshopEmployee
 */
export interface ApiWorkshopEmployee {
    /**
     * 
     * @type {number}
     * @memberof ApiWorkshopEmployee
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiWorkshopEmployee
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ApiWorkshopEmployee
     */
    phoneNumber?: string;
    /**
     * 
     * @type {Array<ApiWorkshop>}
     * @memberof ApiWorkshopEmployee
     */
    workshops: Array<ApiWorkshop>;
}

export function ApiWorkshopEmployeeFromJSON(json: any): ApiWorkshopEmployee {
    return ApiWorkshopEmployeeFromJSONTyped(json, false);
}

export function ApiWorkshopEmployeeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiWorkshopEmployee {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'workshops': ((json['workshops'] as Array<any>).map(ApiWorkshopFromJSON)),
    };
}

export function ApiWorkshopEmployeeToJSON(value?: ApiWorkshopEmployee | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'phoneNumber': value.phoneNumber,
        'workshops': ((value.workshops as Array<any>).map(ApiWorkshopToJSON)),
    };
}

